import * as React from 'react'
import Stack from '@mui/material/Stack'
import { PreviewBody, PreviewHeader } from './styled'
import { IReferral } from '@sales-center/common'

type Props = {
  referral: IReferral
}

export function OtherPreview(props: Props) {
  const { referral } = props
  return (
    <Stack>
      <PreviewHeader>Other</PreviewHeader>
      <PreviewBody>Other Source: {referral.referralValue}</PreviewBody>
    </Stack>
  )
}
